import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const ChevronEndRightIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 16,
  height = 16,
  customColour,
  ...rest
}) => {
  const className = customColour ? '' : 'interactiveColor'

  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <path
        d="M2.5,0 L10,7.5 L2.5,15 L1,13.5 L7,7.5 L1,1.5 L2.5,0 Z M15,0 L15,15 L13,15 L13,0 L15,0 Z"
        data-testid="icon-chevronEndRight"
        fill={customColour}
        className={styles[className]}
      />
    </Icon>
  )
}
